module.exports = __webpack_public_path__ + "static/media/Female Doctor - Default img.40dcb28b.png";